export default __webpack_public_path__ + "static/media/look_out.a94c11bb.mp3";